import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { api } from "@/api/apiClient";
import { useDebounce } from "./use-debounce";

const placesSchema = z.array(
  z.object({
    name: z.string(),
    imageType: z.string(),
  }),
);

export type LocationSearchItem = z.infer<typeof placesSchema>[number];

export function useLocationSearch(search: string, enabled = true) {
  const debouncedSearch = useDebounce(search, 300);

  const {
    data: results = [],
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["route-search", debouncedSearch],
    queryFn: async () =>
      api.get({
        url: `locations?search=${encodeURIComponent(debouncedSearch)}`,
        schema: placesSchema,
      }),
    enabled: enabled && debouncedSearch.length > 0,
    placeholderData: keepPreviousData,
  });

  return {
    results,
    debouncedSearch,
    isLoading,
    refetch,
  };
}
